import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-81N9W9PM5E";

export default function GAListener() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("config", GA_ID, {
      page_path: location.pathname + location.search + location.hash,
      page_title: document.title,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
